/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DocumentGetDocuments$Params {
  fn?: string | null;
  PatientName?: string | null;
}

export function documentGetDocuments(http: HttpClient, rootUrl: string, params?: DocumentGetDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, documentGetDocuments.PATH, 'get');
  if (params) {
    rb.query('fn', params.fn, {});
    rb.query('PatientName', params.PatientName, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

documentGetDocuments.PATH = '/document/getDocuments';
